import axios from 'axios';
import { API_BASE_URL } from "../../../../config/apiConfig";
class HotelService {
  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  }

  setToken(token) {
    this.token = token;
    this.client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  async searchHotels(location, checkInDate, checkOutDate, guests = { adults: 1, children: 0, infants: 0 }, rooms = 1) {
    try {
      const response = await this.client.post('/discover/hotels/search', {
        location,
        checkInDate,
        checkOutDate,
        adults: guests.adults,
        children: guests.children,
        infants: guests.infants,
        rooms
      });
      return response.data;
    } catch (error) {
      console.error('Error searching hotels:', error);
      throw error;
    }
  }

  async getHotelDetails(hotelId) {
    try {
      const response = await this.client.get(`/discover/hotels/${hotelId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching hotel details:', error);
      throw error;
    }
  }

  async searchDestinations(query) {
    try {
      const response = await this.client.get('/discover/destinations/search', {
        params: { q: query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching destinations:', error);
      throw error;
    }
  }
}

export default new HotelService();

